// 正则


// 手机
export const mobilePettern = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
// 密码
export const passwordPettern = /^([A-Za-z0-9`~!@#\\$%\\^&\\*\\)\\(\\+-,\\.\\?;']){6,16}$/
// 身份证
export const idCardPettern = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/
// 邮箱
export const emailPettern = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
// 中文
export const namePettern = /^[\u4e00-\u9fa5]{2,4}$/
// 统一社会信用代码
export const codePettern = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/